import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "15",
  height: "14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5.625 6.1875V11.25M5.625 6.1875H2.87476C2.52472 6.1875 2.34988 6.1875 2.21619 6.24881C2.09859 6.30274 2.00304 6.38873 1.94312 6.49457C1.875 6.61489 1.875 6.77253 1.875 7.08755V11.25H5.625M5.625 6.1875V3.15005C5.625 2.83503 5.625 2.67739 5.69312 2.55707C5.75304 2.45123 5.84859 2.36524 5.96619 2.31131C6.09988 2.25 6.27472 2.25 6.62476 2.25H8.37476C8.72479 2.25 8.90017 2.25 9.03387 2.31131C9.15147 2.36524 9.24672 2.45123 9.30664 2.55707C9.37476 2.67739 9.375 2.83503 9.375 3.15005V4.5M5.625 11.25H9.375M9.375 11.25L13.125 11.2501V5.40005C13.125 5.08503 13.1248 4.92739 13.0566 4.80707C12.9967 4.70123 12.9018 4.61524 12.7842 4.56131C12.6505 4.5 12.475 4.5 12.125 4.5H9.375M9.375 11.25V4.5",
      stroke: "#0EA5E9",
      "stroke-width": "1.3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }